import { useState } from 'react'

import { Box, Modal, Tooltip } from '@mantine/core'
import { FileText, Download } from 'lucide-react'

import DocumentPreview from 'src/components/Overlays/DocumentPreview/DocumentPreview'
import { cn } from 'src/utils'
import { downloadFile } from 'src/utils/downloadFile'

const AttachmentsRow = ({
  attachments,
  applicantId,
  disabled = false,
  disabledText = '',
  wrap = false,
  showActions = false,
  refetchQueries = [],
}) => {
  const [documentForPreview, setDocumentForPreview] = useState(null)

  /************** HANDLERS  **************/
  const handlePreview = (document) => {
    // If there's a custom click handler, use it (e.g., for on-demand URL generation)
    if (document.onClickOverride) {
      document.onClickOverride()
      return
    }

    // If this is a URL-based file, open the presigned URL directly
    if (document.isUrlFile && document.fileUrl) {
      window.open(document.fileUrl, '_blank')
      return
    }

    // Otherwise, open the preview modal for regular documents
    setDocumentForPreview(document)
  }
  return (
    <>
      {documentForPreview && (
        <Modal
          size="90rem"
          lockScroll={false}
          stackId="attachment-preview-modal"
          classNames={{
            content: 'min-h-96 h-[100%]',
            body: 'flex h-[95%] flex-col overflow-auto',
          }}
          transitionProps={{ transition: 'fade', duration: 200 }}
          opened={documentForPreview}
          onClose={() => setDocumentForPreview(null)}
          withCloseButton={false}
        >
          <DocumentPreview
            documentId={documentForPreview.documentId}
            applicantId={applicantId}
            showClosebutton={true}
            showBackButton={false}
            onBack={() => setDocumentForPreview(null)}
            showActions={showActions}
            refetchQueries={refetchQueries}
          />
        </Modal>
      )}
      <div
        className={cn(
          'flex w-full flex-row gap-2 overflow-auto text-nowrap text-xs',
          wrap && 'flex-wrap'
        )}
      >
        {attachments.map((attachment) => (
          <Tooltip
            label={disabled ? disabledText : attachment.fileName}
            key={attachment.documentId}
            size="xs"
          >
            <Box
              className={cn(
                'flex cursor-pointer flex-row gap-1 rounded border border-doubleNickel-gray-200 p-2 shadow-sm hover:bg-doubleNickel-gray-100',
                disabled && 'opacity-50'
              )}
              onClick={() => {
                if (!disabled) handlePreview(attachment)
              }}
            >
              {attachment.isUrlFile ? (
                <Download size={16} strokeWidth={1} />
              ) : (
                <FileText size={16} strokeWidth={1} />
              )}

              <span className="max-w-[200px] truncate">
                {attachment.fileName}
              </span>
            </Box>
          </Tooltip>
        ))}
      </div>
    </>
  )
}

export default AttachmentsRow
